<template>
  <div>
    <v-menu open-on-hover bottom offset-y>
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" dark color="blue">
          <v-icon dark class="mr-1">mdi-share-variant</v-icon>
          <span>Share</span>
        </v-btn>
      </template>

      <v-list class="d-flex flex-column justify-center align-center">
        <v-list-item>
          <v-btn @click="btnShare('btnFacebook')" dark color="#4267B2">
            <v-icon dark>mdi-facebook</v-icon>
          </v-btn>
        </v-list-item>

        <v-list-item>
          <v-btn @click="btnShare('btnTwitter')" dark color="#1da1f2">
            <v-icon dark>mdi-twitter</v-icon>
          </v-btn>
        </v-list-item>
        <v-list-item>
          <v-btn @click="btnShare('btnLinkedin')" dark color="#2867b2">
            <v-icon dark>mdi-linkedin</v-icon>
          </v-btn>
        </v-list-item>
      </v-list>
    </v-menu>

    <social-sharing :url="'https://nearguide.dev.weblevel.pt'+this.$route.fullPath" inline-template>
      <div class="d-none">
        <network network="facebook" id="btnFacebook"></network>
        <network network="linkedin" id="btnLinkedin"></network>
        <network network="twitter" id="btnTwitter"></network>
      </div>
    </social-sharing>
  </div>
</template>

<script>
export default {
  name: "ComponentBtnShare",
  methods: {
    btnShare(id) {
      var btnShare = document.getElementById(id);
      btnShare.click();
    }
  },
  async mounted() {}
};
</script>
